import React from "react"

import Button from "../../../../design-system/button"
import Paragraph from "../../../../design-system/paragraph"
import Title from "../../../../design-system/title"
import * as styles from "./index.module.scss"

type DatoButton = {
  label: string
  url: string
}

type Props = {
  title: string
  subtitle: string
  buttons: DatoButton[]
}

const CallToActionButtons = ({ title, subtitle, buttons }: Props) => (
  <div className={styles.ctaContainer}>
    <div className={styles.textContainer}>
      <Title as="h2">{title}</Title>
      <Paragraph variant="1" className={styles.subtitle}>
        {subtitle}
      </Paragraph>
    </div>
    <div className={styles.buttonsWrapper}>
      {buttons.map(({ label, url }, index) => (
        <Button
          as="a"
          key={label}
          variant={index === 0 ? "primary" : "secondary"}
          href={url}
          trackingProperties={{
            // NOTE(localization): no way to get an English name
            // buttonCta text comes from Dato. The blog is not localized yet,
            // so it's OK, but worthy to leave a note here.
            buttonName: label,
          }}
        >
          {label}
        </Button>
      ))}
    </div>
  </div>
)

export default CallToActionButtons
